import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { string, shape, oneOfType, number, arrayOf, func, bool, oneOf } from 'prop-types';
import LuContentHeader from './LuContentHeader';
import LuContentFooter from './LuContentFooter';
import LuContentContext from './LuContentContext';
import { Container } from './LuContent.styles';
import { CarouselContent, HorizontalContent, HorizontalHighlightContent, VerticalContent } from './variations';
const Variations = {
  carousel: CarouselContent,
  horizontal: HorizontalContent,
  'horizontal-highlight': HorizontalHighlightContent,
  vertical: VerticalContent
};

const LuContent = ({
  variation,
  title,
  linkToMoreContent,
  showLinkToMoreContent,
  data,
  assets,
  onItemClick,
  onSocialMediaClick,
  onLoadMoreClick,
  showHeaderSocialMedia
}) => {
  const carouselView = variation === 'carousel';
  const headerProps = carouselView ? {
    subtitle: title,
    borderRadius: 0
  } : {
    title
  };
  const {
    links,
    images
  } = assets;
  const VariationComponent = (Variations == null ? void 0 : Variations[variation]) || VerticalContent;
  return /*#__PURE__*/React.createElement(LuContentContext, {
    value: {
      images,
      data,
      links,
      linkToMoreContent
    }
  }, /*#__PURE__*/React.createElement(Container, {
    isVerticalView: variation === 'vertical'
  }, /*#__PURE__*/React.createElement(LuContentHeader, _extends({}, headerProps, {
    showLinkToMoreContent: showLinkToMoreContent,
    onSocialMediaClick: onSocialMediaClick,
    showSocialMedias: showHeaderSocialMedia
  })), /*#__PURE__*/React.createElement(VariationComponent, {
    onItemClick: onItemClick,
    onLoadMoreClick: onLoadMoreClick,
    variation: variation
  }), carouselView && /*#__PURE__*/React.createElement(LuContentFooter, {
    onSocialMediaClick: onSocialMediaClick
  })));
};

const itemShape = process.env.NODE_ENV !== "production" ? shape({
  id: oneOfType([string, number]),
  title: string,
  subtitle: string,
  image: string,
  description: string,
  type: string
}) : {};
LuContent.defaultProps = {
  showDetailModal: true,
  showLinkToMoreContent: false,
  data: {
    articles: [],
    videos: [],
    podcasts: []
  },
  detailDirection: 'right',
  assets: {
    images: {
      luImage: '',
      luExplainImage: '',
      blogImage: ''
    }
  },
  onSocialMediaClick: () => {},
  showHeaderSocialMedia: false
};
process.env.NODE_ENV !== "production" ? LuContent.propTypes = {
  variation: oneOf(['vertical', 'horizontal', 'horizontal-highlight', 'carousel']),
  title: string,
  linkToMoreContent: string,
  showLinkToMoreContent: bool,
  data: arrayOf(arrayOf(itemShape)),
  assets: shape({
    links: shape({}),
    images: shape({
      luImage: string,
      luExplainImage: string,
      blogImage: string
    })
  }),
  onLoadMoreClick: func,
  onItemClick: func,
  onSocialMediaClick: func,
  showHeaderSocialMedia: bool
} : void 0;
export default LuContent;